import { baseApi } from "@/shared/api";
import type { PublicSigningInvitation, SigningOperationWithLinks } from "../types/mobileSigning";

interface InvitationArgs {
  invitationId: string;
  secret: string;
}

function invitationHeaders(secret: string): Record<string, string> {
  return { Authorization: `SigningInvitation ${secret}` };
}

export const publicSigningInvitationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPublicSigningInvitation: builder.query<PublicSigningInvitation, InvitationArgs>({
      query: ({ invitationId, secret }) => ({
        url: `/api/signing/v2/invitations/${invitationId}/`,
        method: "GET",
        headers: invitationHeaders(secret),
      }),
      providesTags: (_result, _error, { invitationId }) => [
        { type: "SigningDocumentsV2" as const, id: `invitation:${invitationId}` },
      ],
    }),

    launchPublicSigningInvitation: builder.mutation<SigningOperationWithLinks, InvitationArgs>({
      query: ({ invitationId, secret }) => ({
        url: `/api/signing/v2/invitations/${invitationId}/launch/`,
        method: "GET",
        headers: invitationHeaders(secret),
      }),
    }),
  }),
});

export const { useGetPublicSigningInvitationQuery, useLaunchPublicSigningInvitationMutation } =
  publicSigningInvitationApi;
